let language = {
    // 
    STANDARD_ORDERS_SEARCH_ORDER_NUMBER: "订单号",
    STANDARD_ORDERS_SEARCH_ORDER_DATE: "订单日期:",
    STANDARD_ORDERS_SEARCH_ORDER_STATUS: "状态:",
    STANDARD_ORDERS_SEARCH_STORE_NAME: "店名:",
    STANDARD_ORDERS_SEARCH_PRODUCT_NAME: "产品:",
    
    STANDARD_ORDERS_SEARCH_FORM_RESET_BTN: "重置",
    STANDARD_ORDERS_SEARCH_FORM_SEARCH_BTN: "搜索",

    // 
    STANDARD_ORDERS_HEADER_OPERATION: "操作",
    STANDARD_ORDERS_HEADER_ORDER_NUMBER: "订单号",
    STANDARD_ORDERS_HEADER_ORDER_DATE: "订单日期",
    STANDARD_ORDERS_HEADER_PARTNER_NAME: "名字",
    STANDARD_ORDERS_HEADER_TOTAL_PRICE: "总价",
    STANDARD_ORDERS_HEADER_ORDER_STATUS: "订单状态",
    STANDARD_ORDERS_HEADER_ORDER_TYPE: "拼单方式",
    
    // 
    STANDARD_ORDERS_CONTENT_OPTIONS: "选项",
    STANDARD_ORDERS_CONTENT_OPTIONS_CANCEL_ORDER: "取消订单",
    STANDARD_ORDERS_CONTENT_OPTIONS_SEE_DETAIL: "查看详情",
};

export { language }